import { render, staticRenderFns } from "./InvoiceSidebarAddNewCustomer.vue?vue&type=template&id=59c9977c"
import script from "./InvoiceSidebarAddNewCustomer.vue?vue&type=script&lang=js"
export * from "./InvoiceSidebarAddNewCustomer.vue?vue&type=script&lang=js"
import style0 from "./InvoiceSidebarAddNewCustomer.vue?vue&type=style&index=0&id=59c9977c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports